import { employeeService } from '../../services/employee.service'

const state = {
  employees: [],
  loading: false
}

const mutations = {
  setEmployees (state, employees) {
    state.employees = employees
  },
  setLoading (state, loading) {
    state.loading = loading
  }
}

const actions = {
  fetchEmployees ({ commit }) {
    commit('setLoading', true)
    return employeeService.getAllEmployees().then(employees => {
      commit('setEmployees', employees)
      commit('setLoading', false)
    }).catch(() => {
      commit('setLoading', false)
    })
  },
  saveEmployeePermissions ({ commit }, employee) {
    return employeeService.updateEmployee(employee).then(employees => {
      commit('setEmployees', employees)
    })
  },
  createEmployee ({ commit }, newEmployee) {
    return employeeService.createEmployee(newEmployee).then(employees => {
      commit('setEmployees', employees)
    })
  },
  deleteEmployee ({ commit }, id) {
    return employeeService.deleteEmployee(id).then(employees => {
      commit('setEmployees', employees)
    })
  }
}

export const employees = {
  namespaced: true,
  state,
  mutations,
  actions
}
